// NOTE : this component is a reuseable "swiper js" slider

import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.css";


const SliderPagination = ({
  slidesToShow,
  slidesPerGroup,
  responsiveSettings,
  children,
  space
}) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    const slider = swiperRef.current.swiper;
    if (slider) {
      slider.update(); // Trigger an update when the component mounts 
    }
  }, []);

  return (
    <Swiper
      modules={[Pagination]}
      ref={swiperRef}
      grabCursor={true}
      speed={700}
      slidesPerGroup={slidesPerGroup}
      spaceBetween={space ? space : 0}
      slidesPerView={slidesToShow}
      pagination={{ clickable: true }}
      breakpoints={{...responsiveSettings}}
    >
      {children}
    </Swiper>
  );
};

export default SliderPagination;
